import {
  FileTextIcon,
  Image as ImageIcon,
  MusicNoteIcon,
} from "@phosphor-icons/react";
import type { FileType } from "./types";

// Helper to generate consistent file keys
export const getFileKey = (file: File) => `${file.name}-${file.size}`;

// Helper to get icon for file type
export const getFileIcon = (file: File) => {
  if (file.type.startsWith("image/")) return ImageIcon;
  if (file.type.startsWith("audio/")) return MusicNoteIcon;
  return FileTextIcon;
};

// The i18n key (under `fileUpload.placeholder`) of the empty box's prompt
export const getPlaceholderKey = (type: FileType) => {
  switch (type) {
    case "audio":
    case "image":
    case "document":
      return type;
    default:
      return "any";
  }
};
